import { PayStatsReportQueryController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows pay statistics report for the employment.
 * @example
 * ```html
 * <salaxy-pay-stats-report-query></salaxy-pay-stats-report-query>
 * ```
 */
export class PayStatsReportQuery extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** Optional employment id if not given in url */
      employmentId : "<",
    };

    /** Uses the PayStatsReportQueryController */
    public controller = PayStatsReportQueryController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/report/PayStatsReportQuery.html";

}
